export default __webpack_public_path__ + "static/media/Ashen.1966be61.mp4";